import { MutableRefObject } from 'react';
import { useResizeDetector, useResizeDetectorProps } from 'react-resize-detector';

type ReactResizeDetectorProps<T extends HTMLElement> = Omit<useResizeDetectorProps<T>, 'targetRef'> & {
  targetRef: MutableRefObject<T>;
}

/**
 * Wrapper for useResizeDetector hook, for backwards compatibility purposes (i.e. use in class components).
 */
export function ReactResizeDetector<T extends HTMLElement>(props: ReactResizeDetectorProps<T>): null {
  useResizeDetector({...props});

  return null;
}